import {
  type GeocodeReverseData,
  formatFeatureToAddress,
} from '@ahm/api-wrappers-core';
import type { AxiosRequestConfig } from 'axios';
import { publicEnv } from '@/config/public-env.config.mjs';

// gw-maps gateway — cùng gateway với autocomplete và batch_geocode (2026-08).
// Thay cho ep.ahamove.com + x-api-key trước đây. Đã đối chiếu: response của
// `/wgeo/v2/reverse` trên gw-maps giống hệt EP (byte-for-byte, cả stg lẫn prod).
// Gateway public, không cần api-key; CORS `access-control-allow-origin: *` nên
// gọi thẳng từ browser được — lưu ý allow-headers KHÔNG có `x-api-key`, gửi kèm
// header đó sẽ làm preflight fail.
const MAPS_GW_URI =
  publicEnv.NEXT_PUBLIC_MAPS_GW_URI ?? 'https://gw-maps-stg.ahamove.com';

const REVERSE_PATH = '/wgeo/v2/reverse';

// Chịu được cả base URL lẫn URL đã có sẵn path, để env cấu hình sai cũng không
// nhân đôi path (giống cách get-batch-geocode-fn dựng URL).
const REVERSE_URL = (() => {
  const base = MAPS_GW_URI.replace(/\/+$/, '');
  return base.endsWith(REVERSE_PATH) ? base : `${base}${REVERSE_PATH}`;
})();

export type GeocodeReverseParams = {
  lng: number;
  lat: number;
  profile?: string;
  'boundary.country'?: string;
  'boundary.circle.radius'?: string;
};

export const getGeocodeReverseFn = async (
  params: GeocodeReverseParams,
  config: AxiosRequestConfig = {}
) => {
  const query = new URLSearchParams({
    profile: 'ahamove',
    'boundary.country': 'VN',
    'boundary.circle.radius': '2000',
    ...Object.fromEntries(
      Object.entries(params).map(([key, value]) => [key, String(value)])
    ),
  });

  const response = await fetch(`${REVERSE_URL}?${query.toString()}`, {
    signal: config.signal as AbortSignal | undefined,
  });

  if (!response.ok) {
    throw new Error(`Reverse geocode failed: ${response.status}`);
  }

  const data = (await response.json()) as GeocodeReverseData;
  return formatFeatureToAddress(data.data);
};
